import { Box, Text } from '@fuegokit/react';
import { FuegoSystemStyleObject } from '@fuegokit/react/lib/sx';
import { PropsWithChildren } from 'react';
export function SelectWrapper({
  label,
  children,
  sx,
}: PropsWithChildren<{ label: string; sx?: FuegoSystemStyleObject }>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '2',
        gap: '1',
        ...(sx ?? {}),
      }}
    >
      <Text color="text.default" fontWeight="semibold" fontSize="2" as="label">
        {label}
      </Text>
      {children}
    </Box>
  );
}
